import defaultState from './state'
import Vue from 'vue'
export default {

  setLogs: (state, payload) => {
    if (state.currentPage === 1) {
      state.logs = payload
    } else {
      state.logs.push(...payload)
    }
  },
  setIsCallingLogs: (state, payload) => {
    state.isCallingLogs = payload
  },
  setLogsLastPage: (state, payload) => {
    state.lastPage = payload
  },
  setLogsTotalItems: (state, payload) => {
    state.totalItems = payload
  },
  incrementLogsCurrentPage: state => state.currentPage++,
  clearStoreData: state => {
    const initialState = defaultState.getDefaultState()
    Object.keys(initialState).forEach(key => {
      Vue.set(state, key, initialState[key])
    })
  }

}
